<!-- 
	This is the main page of the application, the layout component is used here,
	and the router-view is passed to it.
	Layout component is dynamically declared based on the layout for each route,
	specified in routes list router/index.js .
 -->

<template>
  <div id="app">
    <a-locale-provider :locale="locale">
      <component :is="layout">
        <router-view />
      </component>
    </a-locale-provider>
  </div>
</template>

<script>
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
export default {
  data() {
    return { locale: zhCN };
  },
  computed: {
    // Sets components name based on current route's specified layout, defaults to
    // <layout-default></layout-default> component.
    layout() {
      return "layout-" + (this.$route.meta.layout || "default").toLowerCase();
    },
  },
};
</script>

<style lang="scss">
.textover {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.textover1 {
  -webkit-line-clamp: 1; // 控制多行的行数
}
.textover2 {
  -webkit-line-clamp: 2; // 控制多行的行数
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
// ::-webkit-scrollbar {
//   background-color: #f5f5f5;
//   width: 10px;
// }
/*定义滚动条轨道 内阴影+圆角*/
// ::-webkit-scrollbar-track {
//   -webkit-box-shadow: inset 0 0 6px 6px rgba(0, 0, 0, 0.1);
//   border-radius: 10px;
//   background-color: #f5f5f5;
// }
/*定义滑块 内阴影+圆角*/
// ::-webkit-scrollbar-thumb {
//   border-radius: 10px;
//   -webkit-box-shadow: inset 0 0 6px 6px rgba(0, 0, 0, 0.05);
//   background-color: #9e9e9e;
// }</style>